/**
 * @fileoverview POST handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/workflows/" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postDecisioningStudioAgentsAppGroupIdDsaIdWorkflowsCacheKeys } from "./constants";
import type {
  PostDecisioningStudioAgentsAppGroupIdDsaIdWorkflowsProps,
  PostDecisioningStudioAgentsAppGroupIdDsaIdWorkflowsResult,
} from "./types";

export const postDecisioningStudioAgentsAppGroupIdDsaIdWorkflows = reactQueryMutationAdapter(
  postDecisioningStudioAgentsAppGroupIdDsaIdWorkflowsCacheKeys,
  (
    props: PostDecisioningStudioAgentsAppGroupIdDsaIdWorkflowsProps
  ): Promise<PostDecisioningStudioAgentsAppGroupIdDsaIdWorkflowsResult> => {
    return fetch(
      `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/workflows/`,
      "POST",
      {
        api_triggered_campaign_from_workflow_step: {
          workflow_step_id: props.workflowStepId,
          message_variation_id: props.messageVariationId,
        },
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
